export default __webpack_public_path__ + "static/charRight-f5f2a683311fe5ef10ec2ae5dd1a58c2.png";